import { MAP_KEY } from '../data/api';

// const BASE_URL = 'http://192.168.0.161:3300'
export const CLIENT_URL = 'https://lucianagrills.com'
export const BASE_URL = 'https://luciana-backend.onrender.com'

export const PLACE_API = `https://maps.googleapis.com/maps/api/place/autocomplete/json?key=${MAP_KEY}&components=country:ng&input=`;
export const VERIFY_PAYMENT_API = `${BASE_URL}/verifyPayment?reference=`
